/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {MasterLayoutLobby} from '../../../_metronic/layout/MasterLayoutLobby'
import {KTUtil} from '../../../_metronic/assets/ts'
import {
  Timer,
} from '../../../_metronic/partials/'

const JollyRoger: FC<{ data: string}> = ({data})=> {


  return (
    <>
        <MasterLayoutLobby>
        {/* begin::Row */}
        <div className='row gy-4 g-xl-8 d-flex flex-row-fluid'>
            {!KTUtil.isMobileDevice() && (
                <div className="container d-flex flex-column">
                    <h1 className="d-flex flex-column-fluid justify-content-center mb-3" >
                        QUI EST-CE ?
                    </h1>
                    <h1 className="d-flex flex-column-fluid justify-content-center my-2" >
                        <Timer />
                    </h1>
                </div>
            )}

            {!KTUtil.isMobileDevice() && (
                <div className="d-flex flex-column">
                    <div className="d-flex flex-row-fluid flex-column flex-center my-2" >
                        <h1 className="d-flex flex-column-fluid justify-content-center my-5"> A QUI APPARTIENT CE DRAPEAU </h1>
                        <img className="card-rounded shadow mw-150 my-7" src={toAbsoluteUrl(data)} alt="" />
                        <input type="text" className="form-control form-control-solid" placeholder="Drapeau" name="Marine"/>
                    </div>
                </div>
                )}

            {/* begin::Aside mobile toggle */}
            {KTUtil.isMobileDevice() && (
                <div className="container d-flex flex-column">
                    <h1 className="d-flex flex-column-fluid justify-content-center my-3" >
                        QUI EST-CE ?
                    </h1>
                    <h1 className="d-flex flex-column-fluid justify-content-center my-2" >
                        <Timer />
                    </h1>
                </div>
            )}

            {KTUtil.isMobileDevice() && (
                <div className="d-flex flex-column">
                    <div className="d-flex flex-row-fluid flex-column flex-center my-5" >
                        <h1 className="d-flex flex-column-fluid justify-content-center my-5"> A QUI APPARTIENT CE DRAPEAU </h1>
                        <img className="card-rounded h-200px w-200px shadow mw-150 my-7" src={toAbsoluteUrl(data)} alt="" />
                        <input type="text" className="form-control form-control-solid" placeholder="Drapeau" name="Marine"/>
                    </div>
                </div>
            )}


        </div>
        {/* end::Row */}
        </MasterLayoutLobby>
    </>
  )
}

export {JollyRoger}
